/* ==========================================================================
   baustoffhandel24 – Theme-Interaktionen (from scratch, kein Framework)
   Nutzt Shopifys Cart-Ajax-API (/cart/*.js) und Predictive Search API.
   ========================================================================== */
(function () {
  "use strict";

  var money = function (cents) {
    return (cents / 100).toLocaleString("de-DE", { style: "currency", currency: window.Shopify && Shopify.currency ? Shopify.currency.active : "EUR" });
  };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  // ---- Toast ---------------------------------------------------------------
  function toast(msg) {
    var el = $("#bh24Toast");
    if (!el) return;
    $("#bh24ToastMsg").textContent = msg;
    el.classList.add("is-open");
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove("is-open"); }, 3000);
  }

  // ---- Cart API ------------------------------------------------------------
  function cartFetch(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function refreshCartCount() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
        return cart;
      });
  }

  function addToCart(id, quantity, properties, opts) {
    opts = opts || {};
    return cartFetch("/cart/add.js", { id: id, quantity: quantity || 1, properties: properties || {} })
      .then(function (res) {
        if (res.status) { toast(res.description || "Fehler beim Hinzufügen."); throw res; }
        return refreshCartCount().then(function () {
          if (opts.silent !== true) toast(opts.message || "Zum Warenkorb hinzugefügt.");
          if (opts.openDrawer !== false) openCartDrawer();
          return res;
        });
      });
  }

  // Mehrere Positionen auf einmal (z. B. Projekt-Assistent) via /cart/add.js { items: [...] }
  function addItemsToCart(items, opts) {
    opts = opts || {};
    return cartFetch("/cart/add.js", { items: items })
      .then(function (res) {
        if (res.status) { toast(res.description || "Fehler beim Hinzufügen."); throw res; }
        return refreshCartCount().then(function () {
          if (opts.silent !== true) toast(opts.message || "Zum Warenkorb hinzugefügt.");
          if (opts.openDrawer !== false) openCartDrawer();
          return res;
        });
      });
  }

  function changeLine(key, quantity) {
    return cartFetch("/cart/change.js", { id: key, quantity: quantity }).then(function (cart) {
      $$("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
      return cart;
    });
  }

  // ---- Quick-Add (Produktkarten) ------------------------------------------
  document.addEventListener("click", function (e) {
    var qa = e.target.closest("[data-quickadd]");
    if (qa) {
      e.preventDefault();
      qa.setAttribute("data-cart-loading", "");
      addToCart(qa.getAttribute("data-quickadd"), 1).finally(function () { qa.removeAttribute("data-cart-loading"); });
    }
  });

  // ---- Produkt-Formular: Menge + Varianten (Apple-Pills) + Add-to-Cart ------
  function initProductForm() {
    var form = $("[data-product-form]");
    if (!form) return;

    var qtyInput = $("[data-qty-input]", form);
    if (qtyInput) {
      var mk = function (delta) {
        return function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta); };
      };
      var minus = $("[data-qty-minus]", form); if (minus) minus.addEventListener("click", mk(-1));
      var plus = $("[data-qty-plus]", form); if (plus) plus.addEventListener("click", mk(1));
    }

    var variantJsonEl = $("[data-variant-json]", form);
    var variants = variantJsonEl ? JSON.parse(variantJsonEl.textContent) : null;

    if (variants) {
      var groups = $$("[data-option-group]", form);

      // aktuell gewählte Optionen (nach Position sortiert)
      var chosenOptions = function () {
        return groups.map(function (g) {
          var checked = $("input:checked", g);
          return checked ? checked.value : null;
        });
      };

      var findVariant = function (opts) {
        return variants.find(function (v) {
          return opts.every(function (val, i) { return val == null || v.options[i] === val; });
        });
      };

      // Apple-Style: nicht kombinierbare Werte ausgrauen/durchstreichen
      var updateAvailability = function () {
        var chosen = chosenOptions();
        groups.forEach(function (g, gi) {
          $$(".variant-pill", g).forEach(function (pill) {
            var input = $("input", pill);
            var probe = chosen.slice();
            probe[gi] = input.value;
            var v = findVariant(probe);
            var ok = v && v.available;
            pill.classList.toggle("is-unavailable", !ok);
          });
        });
      };

      var onChange = function () {
        var chosen = chosenOptions();
        var match = findVariant(chosen);
        // Label + Pill-Status je Gruppe aktualisieren
        groups.forEach(function (g) {
          var checked = $("input:checked", g);
          var label = $("[data-option-selected]", g);
          if (checked && label) label.textContent = checked.value;
          $$(".variant-pill", g).forEach(function (pill) {
            pill.classList.toggle("is-selected", $("input", pill).checked);
          });
        });
        if (!match) { updateAvailability(); return; }

        $("[data-variant-id]", form).value = match.id;
        // 0-€-Schutz: Variante ohne gültigen Preis darf nicht kaufbar sein.
        var onRequest = !match.price || match.price <= 0;
        var priceStr = onRequest ? "Preis auf Anfrage" : money(match.price);
        var priceEl = $("[data-price]");
        if (priceEl) {
          priceEl.textContent = priceStr;
          priceEl.classList.toggle("price--request", onRequest);
          var unitEl = priceEl.parentNode ? priceEl.parentNode.querySelector(".unit") : null;
          if (unitEl) unitEl.style.display = onRequest ? "none" : "";
        }
        var stickyPrice = $("[data-sticky-price]");
        if (stickyPrice) { stickyPrice.textContent = priceStr; stickyPrice.classList.toggle("price--request", onRequest); }
        var cmp = $("[data-compare-price]");
        if (cmp) {
          if (!onRequest && match.compare_at_price > match.price) { cmp.textContent = "statt " + money(match.compare_at_price); cmp.style.display = ""; }
          else { cmp.style.display = "none"; }
        }
        var addBtn = $("[data-add-to-cart]", form); if (addBtn) addBtn.disabled = !match.available || onRequest;
        var stickyBtn = $("[data-sticky-add]"); if (stickyBtn) stickyBtn.disabled = !match.available || onRequest;
        updateAvailability();
      };

      $$("[data-option-input]", form).forEach(function (input) {
        input.addEventListener("change", onChange);
      });
      updateAvailability();
    }

    var submitAdd = function () {
      var addBtn = $("[data-add-to-cart]", form);
      if (!addBtn) return;
      var id = $("[data-variant-id]", form).value;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      addBtn.setAttribute("data-cart-loading", "");
      addToCart(id, qty).finally(function () { addBtn.removeAttribute("data-cart-loading"); });
    };

    form.addEventListener("submit", function (e) {
      if (!$("[data-add-to-cart]", form)) return; // configurator CTA is a link
      e.preventDefault();
      submitAdd();
    });

    var stickyAdd = $("[data-sticky-add]");
    if (stickyAdd) stickyAdd.addEventListener("click", submitAdd);
  }

  // ---- Zuletzt angesehen (localStorage) ------------------------------------
  function initRecentlyViewed() {
    var KEY = "bh24_recent";
    var dataEl = $("[data-current-product]");
    var current = null;
    if (dataEl) { try { current = JSON.parse(dataEl.textContent); } catch (e) {} }

    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) {}

    // aktuelles Produkt vorne einfügen (nur auf PDP)
    if (current && current.handle) {
      list = list.filter(function (i) { return i.handle !== current.handle; });
      list.unshift(current);
      list = list.slice(0, 8);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }

    var section = $("[data-recent]");
    if (!section) return;
    var grid = $("[data-recent-grid]", section);
    var others = list.filter(function (i) { return !current || i.handle !== current.handle; }).slice(0, 4);
    if (!others.length) return;

    grid.innerHTML = others.map(function (i) {
      var img = i.image ? '<img src="' + i.image + '" alt="" loading="lazy" width="600" height="600">' : "";
      var priceLine = i.price ? '<div class="product-card-price-row"><span class="product-card-price">' + i.price + (i.unit ? ' <span class="price-unit">/ ' + i.unit + "</span>" : "") + "</span>" + (i.pack ? '<span class="price-base">' + i.pack + "</span>" : "") + "</div>" : "";
      return '<article class="product-card">' +
        '<div class="product-card-media"><a href="' + i.url + '">' + img + "</a></div>" +
        '<div class="product-card-body">' +
          '<h3 class="product-card-title"><a href="' + i.url + '">' + i.title + "</a></h3>" +
          priceLine +
        "</div></article>";
    }).join("");
    section.hidden = false;
  }

  // ---- Galerie -------------------------------------------------------------
  function initGallery() {
    var gallery = $("[data-gallery]");
    if (!gallery) return;
    var main = $("#galleryMainImg", gallery);
    $$(".gallery-thumbs button", gallery).forEach(function (btn) {
      btn.addEventListener("click", function () {
        main.src = btn.getAttribute("data-thumb");
        $$(".gallery-thumbs button", gallery).forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
      });
    });
  }

  // ---- Warenkorb-Seite: Mengen ändern / entfernen --------------------------
  function initCartPage() {
    var form = $("[data-cart-form]");
    if (!form) return;
    var reload = function () { window.location.reload(); };
    form.addEventListener("click", function (e) {
      var line, key;
      if ((line = e.target.closest("[data-line-remove]"))) {
        changeLine(line.getAttribute("data-line-key"), 0).then(reload);
      } else if ((line = e.target.closest("[data-line-plus]")) || (line = e.target.closest("[data-line-minus]"))) {
        var row = line.closest("[data-cart-line]");
        var input = $("[data-line-qty]", row);
        var delta = line.hasAttribute("data-line-plus") ? 1 : -1;
        var q = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        changeLine(row.getAttribute("data-line-key"), q).then(reload);
      }
    });
    form.addEventListener("change", function (e) {
      var input = e.target.closest("[data-line-qty]");
      if (input) changeLine(input.getAttribute("data-line-key"), Math.max(0, parseInt(input.value, 10) || 0)).then(reload);
    });
  }

  // ---- Cart Drawer (Slide-in) ----------------------------------------------
  var drawerLastFocus = null;

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function renderCartDrawer(cart) {
    var body = $("[data-cart-drawer-body]"), foot = $("[data-cart-drawer-foot]");
    if (!body || !foot) return;
    if (!cart || !cart.items || !cart.items.length) {
      body.innerHTML = '<div class="cart-drawer-empty">' +
        "<p>Dein Warenkorb ist noch leer.</p>" +
        '<a class="btn btn-primary" href="/collections/all" style="margin-top:16px;">Produkte entdecken</a></div>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (item) {
      // Sichtbare Line-Item-Properties (interne mit _ Präfix ausblenden)
      var props = "";
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          if (k.charAt(0) === "_" || item.properties[k] === "" || item.properties[k] == null) return;
          props += '<div class="cart-drawer-prop">' + escapeHtml(k) + ": " + escapeHtml(item.properties[k]) + "</div>";
        });
      }
      var variant = item.variant_title && item.variant_title !== "Default Title"
        ? '<div class="meta">' + escapeHtml(item.variant_title) + "</div>" : "";
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, "_120x$1$2") + '" alt="" width="60" height="60" loading="lazy">'
        : '<span class="cart-drawer-noimg" aria-hidden="true"></span>';
      return '<div class="cart-drawer-line" data-drawer-line data-line-key="' + item.key + '">' +
        '<a class="cart-drawer-line-media" href="' + item.url + '">' + img + "</a>" +
        '<div class="cart-drawer-line-info">' +
          '<a class="name" href="' + item.url + '">' + escapeHtml(item.product_title || item.title) + "</a>" +
          variant + props +
          '<div class="cart-drawer-line-bottom">' +
            '<div class="qty-stepper qty-stepper--sm">' +
              '<button type="button" class="qty-btn" data-drawer-minus aria-label="Weniger">–</button>' +
              '<span class="qty-val" data-drawer-qty>' + item.quantity + "</span>" +
              '<button type="button" class="qty-btn" data-drawer-plus aria-label="Mehr">+</button>' +
            "</div>" +
            '<span class="price">' + money(item.final_line_price) + "</span>" +
          "</div>" +
          '<button type="button" class="cart-drawer-remove" data-drawer-remove>Entfernen</button>' +
        "</div>" +
        "</div>";
    }).join("");

    foot.hidden = false;
    var note = cart.items.some(function (i) { return i.properties && i.properties._Konfiguration; })
      ? '<p class="cart-drawer-note">Konfigurierte Positionen: Der endgültige Preis wird nach Prüfung bestätigt.</p>' : "";
    foot.innerHTML =
      '<div class="cart-drawer-subtotal"><span>Zwischensumme</span><strong>' + money(cart.items_subtotal_price) + "</strong></div>" +
      '<p class="cart-drawer-shipnote">' + "Versand wird im Checkout berechnet. inkl. MwSt." + "</p>" + note +
      '<a class="btn btn-primary btn-block" href="/checkout">Zur Kasse</a>' +
      '<a class="btn btn-outline btn-block" href="/cart" style="margin-top:8px;">Warenkorb ansehen</a>';
  }

  function refreshCartDrawer() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
        renderCartDrawer(cart);
        return cart;
      });
  }

  function openCartDrawer() {
    var drawer = $("#cartDrawer"), overlay = $("#cartDrawerOverlay");
    if (!drawer) return;
    drawerLastFocus = document.activeElement;
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add("is-open"); }); }
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    drawer.inert = false;
    document.body.style.overflow = "hidden";
    refreshCartDrawer();
    var closeBtn = $("#cartDrawerClose");
    if (closeBtn) closeBtn.focus();
  }

  function closeCartDrawer() {
    var drawer = $("#cartDrawer"), overlay = $("#cartDrawerOverlay");
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    drawer.inert = true;
    if (overlay) { overlay.classList.remove("is-open"); setTimeout(function () { overlay.hidden = true; }, 300); }
    document.body.style.overflow = "";
    if (drawerLastFocus && drawerLastFocus.focus) drawerLastFocus.focus();
  }

  function initCartDrawer() {
    var drawer = $("#cartDrawer");
    if (!drawer) return;
    var closeBtn = $("#cartDrawerClose"), overlay = $("#cartDrawerOverlay");
    if (closeBtn) closeBtn.addEventListener("click", closeCartDrawer);
    if (overlay) overlay.addEventListener("click", closeCartDrawer);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) closeCartDrawer();
    });
    // Header-Warenkorb öffnet Drawer statt Seitenwechsel
    var cartLink = $("[data-cart-trigger]");
    if (cartLink) cartLink.addEventListener("click", function (e) { e.preventDefault(); openCartDrawer(); });

    // Menge ändern / entfernen innerhalb des Drawers
    drawer.addEventListener("click", function (e) {
      var line = e.target.closest("[data-drawer-line]");
      if (!line) return;
      var key = line.getAttribute("data-line-key");
      var qtyEl = $("[data-drawer-qty]", line);
      var q = parseInt(qtyEl.textContent, 10) || 1;
      if (e.target.closest("[data-drawer-remove]")) {
        changeLine(key, 0).then(refreshCartDrawer);
      } else if (e.target.closest("[data-drawer-plus]")) {
        changeLine(key, q + 1).then(refreshCartDrawer);
      } else if (e.target.closest("[data-drawer-minus]")) {
        changeLine(key, Math.max(0, q - 1)).then(refreshCartDrawer);
      }
    });
  }

  // ---- Mobile-Nav ----------------------------------------------------------
  function initMobileNav() {
    var toggle = $("#mobileNavToggle"), nav = $("#mobileNav"), overlay = $("#mobileNavOverlay"), close = $("#mobileNavClose");
    if (!toggle || !nav) return;
    var open = function (state) {
      nav.classList.toggle("is-open", state);
      if (overlay) overlay.classList.toggle("is-open", state);
      toggle.setAttribute("aria-expanded", state ? "true" : "false");
      nav.setAttribute("aria-hidden", state ? "false" : "true");
      nav.inert = !state;
      document.body.style.overflow = state ? "hidden" : "";
    };
    toggle.addEventListener("click", function () { open(true); });
    if (close) close.addEventListener("click", function () { open(false); });
    if (overlay) overlay.addEventListener("click", function () { open(false); });
  }

  // ---- Kollektions-Filter (mobile Off-Canvas) ------------------------------
  function initCollectionFilters() {
    var aside = $("[data-facets]");
    if (!aside) return;
    var overlay = $("[data-facet-overlay]");
    var open = function (state) {
      aside.classList.toggle("is-open", state);
      if (overlay) { if (state) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add("is-open"); }); } else { overlay.classList.remove("is-open"); setTimeout(function () { overlay.hidden = true; }, 300); } }
      document.body.style.overflow = state ? "hidden" : "";
    };
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-facet-open]")) { open(true); }
      else if (e.target.closest("[data-facet-close]") || e.target.closest("[data-facet-overlay]")) { open(false); }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && aside.classList.contains("is-open")) open(false);
    });
  }

  // ---- Predictive Search ---------------------------------------------------
  // Shopifys semantische Suche liefert auch für Unsinn („xyzqwkjhg“) Produkte. Treffer gelten nur als
  // passend, wenn ein Suchwort (die ersten 4 Zeichen, oder ein Synonym) in Titel, Typ, Tags oder Text
  // eines Treffers vorkommt. Gleiche Regel + Synonyme wie sections/main-search.liquid (Audit 08.10.2026).
  var SEARCH_SYN = { rigips: "gips", knauf: "gips", gipskarton: "gips", isover: "glaswolle", rockwool: "steinwolle",
    klinke: "griff", "drücker": "griff", druecker: "griff", spax: "schraub", lexan: "polycarbonat", makrolon: "polycarbonat",
    plexi: "acryl", styropor: "eps", styrodur: "xps", bauschaum: "schaum", dachrinne: "rinne", regenrohr: "fallrohr",
    hohlkammer: "steg", dachpappe: "bitumen" };
  function searchRelevant(q, items) {
    var toks = q.toLowerCase().split(/[\s,.\/\-]+/).filter(function (w) { return w.length >= 3 && !/\d/.test(w); });
    if (!toks.length) return true;
    var hay = items.map(function (p) {
      return [p.title, p.product_type, (p.tags || []).join(" "), p.vendor, p.body].join(" ");
    }).join(" ").toLowerCase();
    return toks.some(function (w) {
      if (hay.indexOf(w.slice(0, 4)) > -1) return true;
      return Object.keys(SEARCH_SYN).some(function (k) { return w.indexOf(k) > -1 && hay.indexOf(SEARCH_SYN[k].slice(0, 4)) > -1; });
    });
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  function initSearch() {
    var input = $("#headerSearchInput"), box = $("#searchSuggest");
    if (!input || !box) return;
    var t;
    input.addEventListener("input", function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { box.innerHTML = ""; box.classList.remove("is-open"); return; }
      t = setTimeout(function () {
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product,collection&resources[limit]=6")
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources.results.products) || [];
            if (!products.length || !searchRelevant(q, products)) {
              box.innerHTML = '<div class="search-suggest-empty">Keine Treffer für „' + escapeHtml(q) + "“.</div>";
            } else {
              box.innerHTML =
                '<div class="search-suggest-section"><div class="search-suggest-label">Produkte</div>' +
                products.map(function (p) {
                  return '<a class="search-suggest-item" href="' + p.url + '">' +
                    (p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="" width="40" height="40">' : "") +
                    "<span>" + p.title + "</span></a>";
                }).join("") + "</div>";
            }
            box.classList.add("is-open");
          });
      }, 200);
    });
    document.addEventListener("click", function (e) {
      if (!e.target.closest(".header-search")) box.classList.remove("is-open");
    });
  }

  function initHeaderScroll() {
    var header = document.querySelector("[data-header]");
    if (!header) return;
    var ticking = false;
    var update = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
      ticking = false;
    };
    window.addEventListener("scroll", function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }


  // ---- v4.0 Filterleiste über dem Raster: Pill öffnet Popover, Klick außerhalb/Escape schließt ----
  function initFilterBar() {
    var bar = $("[data-filterbar]");
    if (!bar) return;
    var closeAll = function (except) {
      $$(".fb-item.is-open", bar).forEach(function (it) {
        if (it === except) return;
        it.classList.remove("is-open");
        var b = $("[data-fb]", it); if (b) b.setAttribute("aria-expanded", "false");
      });
    };
    $$("[data-fb]", bar).forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        var it = btn.parentElement, open = !it.classList.contains("is-open");
        closeAll(it);
        it.classList.toggle("is-open", open);
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });
    $$(".fb-pop", bar).forEach(function (pop) { pop.addEventListener("click", function (e) { e.stopPropagation(); }); });
    document.addEventListener("click", function () { closeAll(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });
  }

  // ---- v4.0 Bodenrechner in der Buybox: Fläche inkl. Verschnitt -> ganze Pakete -> Mengenfeld ----
  function initFloorCalc() {
    var box = $("[data-floor-calc]");
    var form = $("[data-product-form]");
    if (!box || !form) return;
    var qty = $("[data-qty-input]", form), addBtn = $("[data-add-to-cart]", form);
    var addLabel = addBtn ? addBtn.textContent.trim() : "";
    var pack = parseFloat(box.dataset.pack), price = parseInt(box.dataset.price, 10);
    var units = box.dataset.units || "Pakete", unit = box.dataset.unit || "Paket";
    var mode = "masse";
    var num = function (el) { return el ? parseFloat(String(el.value).replace(",", ".")) || 0 : 0; };
    var fmt = function (n, d) { return n.toLocaleString("de-DE", { minimumFractionDigits: d, maximumFractionDigits: d }); };
    var set = function (sel, txt) { var el = $(sel, box); if (el) el.textContent = txt; };
    var applied = $("[data-fc-applied]", box);
    var reset = function () { if (applied) applied.classList.remove("is-on"); if (addBtn) addBtn.textContent = addLabel; };

    function calc() {
      var area = mode === "masse" ? num($("[data-fc-l]", box)) * num($("[data-fc-b]", box)) : num($("[data-fc-a]", box));
      var w = $("input[name=fc_waste]:checked", box), waste = w ? parseFloat(w.value) : 0.1;
      if (!(area > 0) || !(pack > 0)) {
        ["[data-fc-r-area]", "[data-fc-r-order]", "[data-fc-r-packs]", "[data-fc-r-sum]"].forEach(function (s) { set(s, "–"); });
        reset(); return;
      }
      var order = area * (1 + waste), n = Math.ceil(order / pack - 1e-9);
      set("[data-fc-r-area]", fmt(area, 2) + " m²");
      set("[data-fc-r-order]", fmt(order, 2) + " m² (+" + Math.round(waste * 100) + " %)");
      set("[data-fc-r-packs]", n + " " + (n === 1 ? unit : units) + " · " + fmt(n * pack, 2) + " m²");
      set("[data-fc-r-sum]", money(n * price));
      if (qty) qty.value = n;
      set("[data-fc-applied-text]", n + " " + (n === 1 ? unit : units) + " ins Mengenfeld übernommen");
      if (applied) applied.classList.add("is-on");
      if (addBtn && !addBtn.disabled) addBtn.textContent = n + " " + (n === 1 ? unit : units) + " in den Warenkorb";
    }
    $$("[data-fc-mode]", box).forEach(function (b) {
      b.addEventListener("click", function () {
        mode = b.dataset.fcMode;
        $$("[data-fc-mode]", box).forEach(function (x) { x.classList.toggle("is-active", x === b); x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
        $("[data-fc-masse]", box).hidden = mode !== "masse";
        $("[data-fc-m2]", box).hidden = mode !== "m2";
        calc();
      });
    });
    $$("[data-fc-l], [data-fc-b], [data-fc-a]", box).forEach(function (el) { el.addEventListener("input", calc); });
    $$("input[name=fc_waste]", box).forEach(function (el) { el.addEventListener("change", calc); });
    // Menge von Hand geändert -> Rechner-Hinweis zurücknehmen
    if (qty) qty.addEventListener("input", reset);
    $$("[data-qty-minus], [data-qty-plus]", form).forEach(function (b) { b.addEventListener("click", reset); });
    // Variantenwechsel: Paketinhalt und Preis der gewählten Variante übernehmen
    var vj = $("[data-variant-json]", form);
    if (vj) {
      var variants = JSON.parse(vj.textContent);
      form.addEventListener("change", function (e) {
        if (!e.target.matches("[data-option-input]")) return;
        var id = parseInt($("[data-variant-id]", form).value, 10);
        var v = variants.filter(function (x) { return x.id === id; })[0];
        if (!v) return;
        price = v.price;
        if (v.unit_price_measurement && v.unit_price_measurement.quantity_value) pack = parseFloat(v.unit_price_measurement.quantity_value);
        calc();
      });
    }
  }


  // ---- v4.2 Service-Buttons mobil: „…“ öffnet/schließt das Menü (Klick außerhalb, Escape, Link-Klick schließen) ----
  function initServiceFabs() {
    var nav = $("[data-service-fabs]");
    if (!nav) return;
    var btn = $("[data-service-fabs-toggle]", nav);
    var set = function (open) {
      nav.classList.toggle("is-open", open);
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      btn.setAttribute("aria-label", open ? "Service-Menü schließen" : "Service-Menü öffnen");
    };
    btn.addEventListener("click", function (e) { e.stopPropagation(); set(!nav.classList.contains("is-open")); });
    document.addEventListener("click", function (e) { if (!nav.contains(e.target)) set(false); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && nav.classList.contains("is-open")) { set(false); btn.focus(); } });
    $$(".service-fab", nav).forEach(function (a) { a.addEventListener("click", function () { set(false); }); });
  }

  document.addEventListener("DOMContentLoaded", function () {
    refreshCartCount();
    initProductForm();
    initGallery();
    initRecentlyViewed();
    initCartPage();
    initMobileNav();
    initSearch();
    initHeaderScroll();
    initCartDrawer();
    initCollectionFilters();
    initFilterBar();
    initFloorCalc();
    initServiceFabs();
  });

  window.BH24Theme = {
    addToCart: addToCart,
    addItemsToCart: addItemsToCart,
    changeLine: changeLine,
    refreshCartCount: refreshCartCount,
    openCartDrawer: openCartDrawer,
    closeCartDrawer: closeCartDrawer,
    refreshCartDrawer: refreshCartDrawer,
    toast: toast,
    money: money
  };
})();
